import React from 'react';
import { CalendarIcon, EmailIcon, ForSaleIcon, SoldIcon } from '@domain-group/fe-co-icon';
import { Button, CallButton } from '@domain-group/fe-co-allhomes-design-system';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import * as styles from './stats-buttons.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Stat = _ref => {
  var icon = _ref.icon,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    description = _ref.description,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'vertical' : _ref$appearance;
  return ___EmotionJSX("div", {
    css: styles.statColumn(appearance)
  }, ___EmotionJSX("div", {
    css: styles.stat
  }, icon, ___EmotionJSX("span", {
    css: styles.statValue
  }, value && value > 0 ? value : '-')), ___EmotionJSX("div", {
    css: styles.statDescription
  }, description));
};
var StatsButtons = _ref2 => {
  var _stats$saleStats;
  var stats = _ref2.stats,
    _ref2$emailContactabl = _ref2.emailContactable,
    emailContactable = _ref2$emailContactabl === void 0 ? false : _ref2$emailContactabl,
    _ref2$onAppraisalClic = _ref2.onAppraisalClick,
    onAppraisalClick = _ref2$onAppraisalClic === void 0 ? () => {} : _ref2$onAppraisalClic,
    _ref2$phone = _ref2.phone,
    phone = _ref2$phone === void 0 ? null : _ref2$phone,
    _ref2$appearance = _ref2.appearance,
    appearance = _ref2$appearance === void 0 ? 'vertical' : _ref2$appearance,
    emailButtonLabel = _ref2.emailButtonLabel,
    consumer = _ref2.consumer;
  var buttonLabel = emailButtonLabel || 'Free appraisal';
  return ___EmotionJSX("div", {
    css: styles.statsButtons(appearance)
  }, ___EmotionJSX("div", {
    css: styles.stats(appearance)
  }, ___EmotionJSX(Stat, {
    icon: SoldIcon({}),
    value: stats === null || stats === void 0 ? void 0 : stats.sold,
    description: "Sold",
    appearance: appearance
  }), ___EmotionJSX(Stat, {
    icon: ForSaleIcon({}),
    value: stats === null || stats === void 0 ? void 0 : stats.sales,
    description: "For sale",
    appearance: appearance
  }), ___EmotionJSX(Stat, {
    icon: CalendarIcon({}),
    value: stats === null || stats === void 0 ? void 0 : (_stats$saleStats = stats.saleStats) === null || _stats$saleStats === void 0 ? void 0 : _stats$saleStats.daysOnMarket,
    description: "Avg. days advertised",
    appearance: appearance
  })), ___EmotionJSX("div", {
    css: consumer === 'agency' ? styles.buttonsAgency(appearance) : styles.buttons(appearance)
  }, emailContactable && ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX(Button, {
    css: styles.button(appearance),
    icon: ___EmotionJSX(EmailIcon, null),
    onClick: onAppraisalClick
  }, buttonLabel)), phone && ___EmotionJSX(CallButton, {
    css: styles.button(appearance),
    phone: phone
  })));
};
export default StatsButtons;